import { render, staticRenderFns } from "./ImportSupplierPrices.vue?vue&type=template&id=1ffc05e2&scoped=true"
import script from "./ImportSupplierPrices.vue?vue&type=script&lang=js"
export * from "./ImportSupplierPrices.vue?vue&type=script&lang=js"
import style0 from "./ImportSupplierPrices.vue?vue&type=style&index=0&id=1ffc05e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffc05e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ffc05e2')) {
      api.createRecord('1ffc05e2', component.options)
    } else {
      api.reload('1ffc05e2', component.options)
    }
    module.hot.accept("./ImportSupplierPrices.vue?vue&type=template&id=1ffc05e2&scoped=true", function () {
      api.rerender('1ffc05e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/supplier-prices/ImportSupplierPrices.vue"
export default component.exports